(function () {
  'use strict';

  const boundCarousels = new WeakSet();
  const trackedCarousels = new WeakSet();

  function analyticsAllowed() {
    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') {
      return false;
    }

    return customerPrivacy.analyticsProcessingAllowed();
  }

  function linkPath(target) {
    const link = target.closest('a[href]');
    if (!link) return '';

    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return link.getAttribute('href') || '';
    }
  }

  function pushHomepageEvent(eventName, target, interactionType) {
    if (!eventName || !analyticsAllowed()) return false;

    const section = target.closest('[data-homepage-section]');
    const payload = {
      event: eventName,
      homepage_section: section ? section.dataset.homepageSection : 'unknown'
    };

    const itemName = target.dataset.homepageItemName;
    const itemId = target.dataset.homepageItemId;
    const itemPosition = Number.parseInt(target.dataset.homepagePosition, 10);
    const itemUrl = linkPath(target);
    const resolvedInteractionType = interactionType || target.dataset.homepageInteraction;

    if (itemName) payload.homepage_item_name = itemName;
    if (itemId) payload.homepage_item_id = itemId;
    if (Number.isFinite(itemPosition)) payload.homepage_item_position = itemPosition;
    if (itemUrl) payload.homepage_item_url = itemUrl;
    if (resolvedInteractionType) payload.homepage_interaction_type = resolvedInteractionType;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    return true;
  }

  function trackCarousel(carousel, interactionType) {
    if (!carousel || trackedCarousels.has(carousel)) return;

    if (pushHomepageEvent('homepage_carousel_interaction', carousel, interactionType)) {
      trackedCarousels.add(carousel);
    }
  }

  function bindCarousel(carousel) {
    if (boundCarousels.has(carousel)) return;
    boundCarousels.add(carousel);

    const initialScrollPosition = carousel.scrollLeft;
    carousel.addEventListener('scroll', function handleCarouselScroll() {
      if (Math.abs(carousel.scrollLeft - initialScrollPosition) < 4) return;
      trackCarousel(carousel, 'swipe_or_scroll');
    }, { passive: true });
  }

  function bindCarousels(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const carousels = scope.querySelectorAll('[data-homepage-carousel]');

    for (const carousel of carousels) {
      bindCarousel(carousel);
    }
  }

  function handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const trackedTarget = event.target.closest('[data-homepage-event]');
    if (trackedTarget) {
      pushHomepageEvent(trackedTarget.dataset.homepageEvent, trackedTarget);
    }

    const carouselControl = event.target.closest('[data-carousel-prev], [data-carousel-next], .carousel-dot');
    if (!carouselControl) return;

    const carouselRoot = carouselControl.closest('[data-carousel-root]');
    const carousel = carouselRoot && carouselRoot.querySelector('[data-homepage-carousel]');
    let interactionType = 'pagination';

    if (carouselControl.hasAttribute('data-carousel-prev')) interactionType = 'previous';
    if (carouselControl.hasAttribute('data-carousel-next')) interactionType = 'next';

    trackCarousel(carousel, interactionType);
  }

  function boot(root) {
    if (!document.body.classList.contains('template-index')) return;
    bindCarousels(root);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    }, { once: true });
  } else {
    boot(document);
  }
})();
